import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { useForm } from "react-hook-form";
import Content from "../../layout/content/Content";
import { Block, Col, DataTable, PreviewAltCard, Row } from "../../components/Component";
import { Form, Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";

import { createBrandAPI, createIngredientAPI, listBrandAPI, listIngredientAPI, updateBrandAPI, updateIngredientAPI } from "../../api/master/indes";

import { toast } from "react-toastify";

import { BASE_URL_IMG } from "../../assets/constants";
import MyButton from "../../MyComp/UI/form/MyButton";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import MyInput from "../../MyComp/UI/form/MyInput";
import Status from "../../MyComp/UI/form/Status";
import useLogout from "../../hooks/useLogout";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import MyTextArea from "../../MyComp/UI/form/MyTextArea";
import Table from "../../MyComp/UI/DataTable/Table";
const Ingredients = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],
      meta_image: null,
      meta_img: null,
      product_banner_img: null,
      product_banner_image: null,
      product_images: [],
      productTypeDD: [],
      brandsDD: [],
      categoryDD: [],
      unitDD: [],
      ingredientDD: [],
      diseaseDD: [],
      isPub: false,
    },
  });
  const logout = useLogout();
  const [isOpenc, setIsOpenc] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const [data, setData] = useState([]);
  const [openCanvas, setOpenCanvas] = useState(false);

const toggleCanvas = () => {
  setIsOpen((prev) => !prev);
  if (isOpen) resetF(); 
};

  const selectorCheck = (e) => {
    const updated = data.map((item) => ({ ...item, checked: e.target.checked }));
    setData(updated);
  };
  const handleTogglePublish = (row) => {
    setValue("isPub", true);
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const selectorDeleteUser = () => setData(data.filter((d) => !d.checked));
 const handleImageOpenPreview = (row) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };



  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };

  const onSelectChange = (e, id) => {
    const updated = data.map((item) => (item.id === id ? { ...item, checked: e.target.checked } : item));
    setData(updated);
  };
  const selectorSuspendUser = () => setData(data.map((d) => (d.checked ? { ...d, status: false } : d)));
 useEffect(() => {
    getIngredientsList();
  }, []);
   const getIngredientsList = () => {
      listIngredientAPI()
        .then((res) => {
          if (res.data.status === "expired") {
            toast.error(res.data.message);
            logout();
          } else if (res.data.status === true) { 
            setData(res.data.data);
            setValue("isLoading", false);
          } else {
            setData([]);
            setValue("isLoading", false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    };
  const onFormSubmit = (data) => {
    const body = {
      name: watch("ingredient"),
      status: watch("status")?.value,
      ...(mode == "Edit" && { id: watch("selectedRow")?.id }),
    };
    const formData = new FormData();
    formData.append("status", watch("status")?.value);
    formData.append("name", watch("ingredient"));
    formData.append("description", watch("description"));
    const i = watch("ingredient_img");
    if (data?.ingredient_img) {
      formData.append("img", i);
    }
    if (mode == "Edit") {
      formData.append("id", watch("selectedRow")?.id);
    }
    if (mode == "Add") {
      createIngredientAPI(formData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getIngredientsList();
            setIsOpen(false);
            resetF();
            setValue("isLoading", false);
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
    if (mode == "Edit") {
      updateIngredientAPI(formData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getIngredientsList();
            setIsOpen(false);
            resetF();
            setValue("isLoading", false);
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
  };
  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setValue("selectedRow", row);
    setIsOpen(true);
    setMode("Edit");
    setValue("ingredient", row?.name);
    setValue("description", row?.description);
    const imageUrl = `${BASE_URL_IMG}${row.image}`;
    setValue("ingredient_image", imageUrl); //image_url value
    setValue("status", {
      label: row.status ? "Active" : "InActive",
      value: row.status,
    });
  };
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const confirmStatusChange = (data) => {
    const updatedStatus = watch("selectedRow").status === true ? false : true;
    setValue("isLoading", true);
    const formObject = {
      id: watch("selectedRow").id,
      status: updatedStatus,
    };
    updateIngredientAPI(formObject)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getIngredientsList();
          setIsOpen(false);
          resetF();
          setValue("isLoading", false);
          setShowModal(false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const resetF = () => {
    setValue("status", "");
    setValue("ingredient", "");
    setValue("description", "");
    setValue("ingredient_image", null);
    setMode("Add")
  };
  return (
    <>
      <Head title={"Product | Master"} />
      <Content>
        {/* <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Products"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead> */}
        <Block>
          <>
            {" "}
            <div className="container my-5 text-center">
              {/* Button to open offcanvas */}

              <Offcanvas isOpen={isOpen} direction="end">
                <OffcanvasHeader toggle={toggleCanvas}>Ingredient </OffcanvasHeader>
                <OffcanvasBody>
                     <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  <Col md="12" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Ingredient"}
                      name={"ingredient"}
                      placeholder={"Enter ingredient name"}
                      required
                      min={2}
                      max={50}
                    />
                  </Col>
                  <Col md={12}>
                    <ImageUpload
                      id="ingredient_image"
                      watch={watch}
                      label={"Upload Ingredient Image"}
                      errors={errors}
                      register={register}
                      clearErrors={clearErrors}
                      trigger={trigger}
                      image={"ingredient_img"}
                      image_url={"ingredient_image"}
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      required
                      getValues={getValues}
                    />
                  </Col>
                  <Col md={`12`}>
                    <Status register={register} watch={watch} setValue={setValue} trigger={trigger} errors={errors} />
                  </Col>
                </Row>
                <Col md="12" className={``}>
                  <MyTextArea
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Description"}
                    name={"description"}
                    placeholder={"Enter short disease description"}
                    required
                    min={25}
                    max={300}
                    cols={2}
                    row={2}
                  />
                </Col>
                <Col md="12" className={``}>
                  <div className="form-group" style={{ marginTop: "31px" }}>
                    <MyButton isLoading={isLoading} mode={mode} />
                  </div>
                </Col>
              </Form>
            </PreviewAltCard>
                </OffcanvasBody>
              </Offcanvas>

              {/* Offcanvas (Right Side) */}
            </div>
          </>

          <Table
            title="Ingredients List"
            data={data}
            publicButton={false}
         columns=  { [
//   { key: "id", label: "Id" },
  { key: "image", label: "Name",type: "image" },
//   { key: "name", label: "Name" },
//   { key: "doc_type", label: "Doc Type" },

  { key: "description", label: "Description" },
//   { key: "status", label: "Status" },
//   { key: "createdBy", label: "Created By" },
//   { key: "updatedBy", label: "Updated By" },
//   { key: "createdAt", label: "Created At" },
//   { key: "updatedAt", label: "Updated At" }
]}

            searchKeys={["name"]}
            nameColumn={"name"}
            imageBaseURL={BASE_URL_IMG}
            onEditClick={handleEdit}
            selectorCheck={selectorCheck}
            selectorDeleteUser={selectorDeleteUser}
            selectorSuspendUser={selectorSuspendUser}
            onSelectChange={onSelectChange}
            statusFilterEnabled={true}
            isOpen={isOpen}
            confirmStatusChange={confirmStatusChange}
            setIsOpen={setIsOpen}
            resetF={resetF}
            handleImageOpenPreview={handleImageOpenPreview}
            handleToggleStatus={handleToggleStatus}
            toggleCanvas={toggleCanvas}
            handleTogglePublish={handleTogglePublish}
          />

          {/* <MyDataTable data={data || []} columns={column} title={"Product List"} isLoading={isLoading} /> */}
        </Block>
      </Content>
      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
      <ConfirmModal
        isOpen={showModal}
        toggle={() => {
          setShowModal(!showModal);
          setValue("isPub", false);
        }}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        isPub={watch("isPub")}
        data={watch("selectedRow")}
      />
    </>
  );
};

export default Ingredients;
